/** 本番カスタムドメイン（Cloudflare Pages 本番） */
export const PRODUCTION_HOST = "verite-f.co.jp";
export const PRODUCTION_HOST_WWW = "www.verite-f.co.jp";

export const SITE_ORIGIN = `https://${PRODUCTION_HOST}`;

export function isProductionHost(
  hostname = typeof window !== "undefined" ? window.location.hostname : PRODUCTION_HOST,
): boolean {
  return hostname === PRODUCTION_HOST || hostname === PRODUCTION_HOST_WWW;
}

/** Deploy Preview・Branch deploy・ローカル開発 */
export function isPreviewHost(
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
): boolean {
  return (
    hostname.endsWith(".pages.dev") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  );
}
